import React from 'react';
import { Typography, ListItem, ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define brand colors
const ACCENT_TEAL = '#2ec4b6';
const TEXT_COLOR = '#222';

const Root = styled(ListItem)(({ theme }) => ({
  width: '100%',
  padding: 0,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(0.5),
  },
}));

const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'isAvailable'
})(({ theme, isAvailable }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.spacing(1),
  border: `2px solid ${isAvailable ? ACCENT_TEAL : '#cccccc'}`,
  padding: theme.spacing(1.5),
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: isAvailable ? `${ACCENT_TEAL}15` : 'inherit',
  },
  '&:disabled': {
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    minHeight: '40px',
  },
}));

const ValueText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isAvailable'
})(({ theme, isAvailable }) => ({
  fontFamily: "'Helvetica Inserat', Arial, sans-serif",
  fontSize: '1.1rem',
  fontWeight: 600,
  color: isAvailable ? TEXT_COLOR : '#999999',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}));

const ValueItem = ({ question, onSelect }) => {
  const isAvailable = question && !question.picked;

  return (
    <Root>
      <StyledListItemButton
        onClick={() => isAvailable && onSelect()}
        disabled={!isAvailable}
        isAvailable={isAvailable}
      >
        <ValueText isAvailable={isAvailable}>
          {question.label}
        </ValueText>
      </StyledListItemButton>
    </Root>
  );
};

export default ValueItem; 